module.exports = __webpack_public_path__ + "img/band.ecd5d962.jpg";